import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";


function Organization() {
    const navigate = useNavigate();
	const [userData, setUserData] = useState(null);
	

	useEffect(() => {
		const authToken = localStorage.getItem("authToken");
        //console.log("authToken",authToken)
		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}else{
			const storedUser = JSON.parse(localStorage.getItem("user"));
			//console.log("storedUser",storedUser)
			setUserData(storedUser);
		}

	}, [navigate]);
	
	const [formData, setFormData] = useState({
		c_org_name: "",
		n_org_type: "",
		c_org_address: "",
		n_org_phone: "",
		c_cp_name: "",
		n_cp_contact: "",
		c_cp_email: ""
	  });
	  
	
	 const [errors, setErrors] = useState({});
     const [orgtype, setOrgTypeList] = useState([]);
	 const [participantsprofession, setParticipantsProfessionList] = useState([]);
	 const [gender, setGenderList] = useState([]);
	 const [yesno, setYesNoList] = useState([]);
	 const [internes, setRaporteeList] = useState([]);
	 const [columns, setColumns] = useState([]);
	 const [tabledata, settableData] = useState([]);	
	 const [selectedUser, setSelectedUser] = useState(null);
     const [editMode, setEditMode] = useState(false);
     const [modalData, setModalData] = useState(false);
     const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
     const [indiid, setModalId] = useState(null);	
     const [raporteedata, setRapporteeData] = useState({
	  n_stakeholder_id : ""
      });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {
	//console.log("encode",strEncode('pmis_app_messages'))
	 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_organization_type_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setOrgTypeList(res.data);
	    }).catch( (error) => { console.log(error); });
  
	
	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_organization_mst'),cols:strEncode('*') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "فعل",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   </div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
	    c_org_name: "",
		n_org_type: "",
		c_org_address: "",
		n_org_phone: "",
		c_cp_name: "",
		n_cp_contact: "",
		c_cp_email: ""
	});
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }


  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_organization_mst'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 setFormData({
		id : response.data[0].id,
	    c_org_name: response.data[0].c_org_name,
		n_org_type: response.data[0].n_org_type,
		c_org_address: response.data[0].c_org_address,
		n_org_phone: response.data[0].n_org_phone,
		c_cp_name: response.data[0].c_cp_name,
		n_cp_contact: response.data[0].n_cp_contact,
		c_cp_email: response.data[0].c_cp_email	
	});

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  
   // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	
	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};
	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		//console.log("formdata",formData)
		try {
		  //console.log("formdata afeter",formData)
		  const payload = {
				data: {
					...formData,
					n_user_id: userData?.id
				}
				};

		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/organization/create`,  payload );
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/organization/update`, {id: formData.id,
 data: formData });
			alert("تم تحديث البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
			c_org_name: "",
			n_org_type: "",
			c_org_address: "",
			n_org_phone: "",
			c_cp_name: "",
			n_cp_contact: "",
			c_cp_email: ""
		  });
	  
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };

	  

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">إدارة المستخدمين</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
           
           <span className="d-sm-block d-none">قائمة</span>
		  </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}>
            <span className="d-sm-block d-none">إضافة منظمة جديدة</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<DataTable
									title="قائمة المنظمة"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
							<div className="row mb-15px" key="c_name">
									<label className="form-label col-form-label col-md-3">اسم المنظمة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_org_name"
										value={formData.c_org_name}
										onChange={handleChange}
										/>
                                     {errors.c_org_name && <span style={{ color: "red" }}>{errors.c_org_name}</span>}
									</div>
									</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">نوع المنظمة</label>
									<div className="col-md-9">
									<select name="n_org_type" className="form-select" onChange={handleChange} value={formData.n_org_type}>
										<option value="">حدد النوع</option>
										{orgtype.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_org_type && <span style={{ color: "red" }}>{errors.n_org_type}</span>}
									</div>
								</div>

									<div className="row mb-15px" key="c_name">
									<label className="form-label col-form-label col-md-3">عنوان المنظمة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_org_address"
										value={formData.c_org_address}
										onChange={handleChange}
										/>
                                     {errors.c_org_address && <span style={{ color: "red" }}>{errors.c_org_address}</span>}
									</div>
									</div>

																
									<div className="row mb-15px" key="n_age">
									<label className="form-label col-form-label col-md-3">هاتف المنظمة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_org_phone"
										value={formData.n_org_phone}
										onChange={handleChange}
										/>
                                     {errors.n_org_phone && <span style={{ color: "red" }}>{errors.n_org_phone}</span>}
									</div>
									</div>
                               
							       	<div className="row mb-15px" key="c_academic_achivement">
									<label className="form-label col-form-label col-md-3">اسم جهة الاتصال</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_cp_name"
										value={formData.c_cp_name}
										onChange={handleChange}
										/>
                                     {errors.c_cp_name && <span style={{ color: "red" }}>{errors.c_cp_name}</span>}
									</div>
									</div>

                                     <div className="row mb-15px" key="n_phone_no">
									<label className="form-label col-form-label col-md-3">جهة الاتصال جهة الاتصال</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_cp_contact"
										value={formData.n_cp_contact}
										onChange={handleChange}
										/>
                                     {errors.n_cp_contact && <span style={{ color: "red" }}>{errors.n_cp_contact}</span>}
									</div>
									</div>
                               
                    <div className="row mb-15px" key="n_phone_no_alt">
									<label className="form-label col-form-label col-md-3">البريد الإلكتروني لجهة الاتصال </label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="email"
										name= "c_cp_email"
										value={formData.c_cp_email}
										onChange={handleChange}
										/>
                                     {errors.c_cp_email && <span style={{ color: "red" }}>{errors.c_cp_email}</span>}
									</div>
								</div>

									
                               {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">يحفظ</button>
								:
								<button type="submit" className="btn btn-success w-100px">تحديث</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
		
		</div>
	)
}

export default Organization;